export const DARK = {
  bg:       "#0F0A06",
  bgApp:    "#1A1208",
  border:   "#3D2E18",
  borderW:  "#3D2E18",
  card:     "#241A0E",
  chip:     "#241A0E",
  chipText: "#8A7458",
  cream:    "#F2EFE9",
  error:    "#C76B5A",
  gold:     "#C9A870",
  goldDim:  "#A88040",
  goldHi:   "#E8D5A3",
  hover:    "#2E2010",
  info:     "#5A8AE0",
  input:    "#241A0E",
  lift:     "#2E2010",
  mute:     "#8A7458",
  muteTxt:  "#4A4030",
  ok:       "#2A9D6A",
  r:        "8px",
  sec:      "#9A8A78",
  shadow:   "rgba(0,0,0,0.6)",
  sidebar:  "#120D06",
  text:     "#E8D8B8",
  textSub:  "#B8986A",
};
export const LIGHT = {
  bg:       "#F2EFE9",
  bgApp:    "#EAE6DF",
  border:   "#C4BEB4",
  borderW:  "#C4BEB4",
  card:     "#FFFFFF",
  chip:     "#EAE6DF",
  chipText: "#7A7060",
  cream:    "#1A1612",
  error:    "#C76B5A",
  gold:     "#8A6820",
  goldDim:  "#B8922A",
  goldHi:   "#C9A870",
  hover:    "#CCC6BA",
  info:     "#5A8AE0",
  input:    "#FFFFFF",
  lift:     "#EDE8DF",
  mute:     "#7A7060",
  muteTxt:  "#9A8A7A",
  ok:       "#2A9D6A",
  r:        "8px",
  sec:      "#7A7060",
  shadow:   "rgba(0,0,0,0.15)",
  sidebar:  "#D8D2C8",
  text:     "#1A1612",
  textSub:  "#5A5040",
};